import {
  ColDef,
  ICellRendererParams,
  ValueGetterParams,
} from "ag-grid-community";
import { UserActivityCell } from "@/components/common/data-grid-cells/UserActivityCell";

export const modifiedByColumnDef: ColDef = {
  field: "modified_by",
  width: 300,
  minWidth: 250,

  headerName: "Last Modified By",
  cellRenderer: ({ data, node }: ICellRendererParams) => {
    if (!data || node.footer) {
      return null;
    }

    const details = data?.modified_by;

    if (!details) {
      return "-";
    }

    return (
      <UserActivityCell
        date={data.modified_at ?? undefined}
        name={details?.name ?? details?.email ?? ""}
        deleted={details?.status === "deleted"}
        profile={details?.profile}
      />
    );
  },
  valueGetter: ({ data }: ValueGetterParams) =>
    data?.modified_by?.name ?? data?.modified_by?.email,
};
